<div id="treeMapDiv" #treeMapchart style="width: 100%; height: 100%;"></div>

<ng-template #treeMapTooltip>
    <app-tree-map-tooltip [tooltipData]="tooltipData" [colorPalette]="colorPalette" [spikeColor]="spikeColor" [spikeColor]="spikeColor" [chartType]="chartType"></app-tree-map-tooltip>
</ng-template>